import React, { useEffect, useState } from "react";
import "./alertReceiver.scss";
import { Button, Col, Popconfirm, Row, Table, Tag, Typography } from "antd";
import Icon from "../../../../components/icon/icon";
import { HandleErrors } from "../../../../utils/handleErrors";

import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { GetPermissionRes } from "../../../../interfaces/role.interface";
import { PermissionCode } from "../../../../enum/permission";
import { GetAlertReceiverRes } from "../../../../interfaces/alert.interface";
import {
  deleteAlertReceiverService,
  getAllAlertReceiverService,
} from "../../../../services/alert.service";
import { AddAlertReceiverModal } from "../../../../components/addAlertReceiverModal/addAlertReceiverModal";
import { UpdateAlertReceiverModal } from "../../../../components/updateAlertReceiverModal/updateAlertReceiverModal";

export const AlertReceiver = () => {
  const health = useSelector<RootState, string>((root) => root.app.health);

  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [addAlertReceiverModal, setAddAlertReceiverModal] = useState(false);
  const [updateAlertReceiverModal, setUpdateAlertReceiverModal] =
    useState(false);

  const [selectAlertReceiver, setSelectAlertReceiver] =
    useState<GetAlertReceiverRes>({
      id: 0,
      name: "",
      type: "",
      active: true,
      email_address: "",
      webhook_uri: "",
      created_at: "",
    });

  const [data, setData] = useState<GetAlertReceiverRes[]>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      if (health == "license-false") {
        return;
      }
      setLoading(true);
      const res = await getAllAlertReceiverService({});
      setData(res.list);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const deleteAlertReceiver = async (item: GetAlertReceiverRes) => {
    try {
      setDeleteLoading(true);
      await deleteAlertReceiverService({ id: item.id });
      await getData();
      setDeleteLoading(false);
    } catch (error) {
      HandleErrors(error);
      setDeleteLoading(false);
    }
  };

  const columns = [
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "نوع",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "وضعیت",
      dataIndex: "active",
      key: "active",
      render: (active: boolean) => {
        return (
          <div>
            {active && <Tag color={"green"}>فعال</Tag>}
            {!active && <Tag color={"red"}>غیر فعال</Tag>}
          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (item: any, record: any) => (
        <div className="btn-box">
          {userPermissions.find(
            (p) => p.code === PermissionCode.updateAlertReceiver
          ) && (
            <div
              className="btn"
              onClick={() => {
                setSelectAlertReceiver(record);
                setUpdateAlertReceiverModal(true);
              }}
            >
              <Icon src="/assets/icons/Pen.svg" />
            </div>
          )}
          {userPermissions.find(
            (p) => p.code === PermissionCode.deleteAlertReceiver
          ) && (
            <div className="del-btn">
              <Popconfirm
                title={`حذف گیرنده: ${record.name}`}
                description="گیرنده حذف شده قابل بازیابی نیست، مطمئن هستید؟"
                onConfirm={() => {
                  deleteAlertReceiver(record);
                }}
                onCancel={() => {}}
                okText="حذف شود"
                cancelText="لغو"
              >
                <Button type="text" loading={deleteLoading}>
                  <i className="las la-trash delete-icon"></i>
                </Button>
              </Popconfirm>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="AlertReceiver">
      {health == "license-false" && (
        <div
          style={{
            position: "absolute",
            zIndex: "100000",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)" /* optional tint */,
          }}
        ></div>
      )}
      <Row align={"middle"} justify={"space-between"} className="title-box">
        <Col>
          <Typography.Text className="title">مدیریت گیرنده ها</Typography.Text>
        </Col>
        <Col md={5} xs={15}>
          {userPermissions.find(
            (p) => p.code === PermissionCode.createAlertReceiver
          ) && (
            <div
              className="btn-box"
              onClick={() => {
                setAddAlertReceiverModal(true);
              }}
            >
              <Icon src="/assets/icons/Add - Circle.svg" />
              <Typography.Text className="title">
                افزودن گیرنده جدید{" "}
              </Typography.Text>
            </div>
          )}
        </Col>
      </Row>

      <Row className="table-container">
        <Col xs={24} style={{ minWidth: "400px" }}>
          <Table dataSource={data} columns={columns} loading={loading} />
        </Col>
      </Row>

      <AddAlertReceiverModal
        show={addAlertReceiverModal}
        onClose={() => {
          getData();
          setAddAlertReceiverModal(false);
        }}
      />

      <UpdateAlertReceiverModal
        show={updateAlertReceiverModal}
        onClose={() => {
          getData();
          setUpdateAlertReceiverModal(false);
        }}
        data={selectAlertReceiver}
      />
    </div>
  );
};
